import SafeGatsbyImage from './SafeGatsbyImage';

export default SafeGatsbyImage;
